<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 商品信息 -->
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('fms_commodity_edit_dialog.spbmkpxt')" prop="itemCode">
              <el-input v-model="form.itemCode" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_commodity_edit_dialog.mrkplx')" prop="invoiceType">
              <custom-select code="invoice_type" v-model="form.invoiceType" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_commodity_edit_dialog.fei_yong_lei_xing')" prop="billType">
              <custom-select code="bill_type" v-model="form.billType" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_commodity_edit_dialog.shang_pin_ming_cheng')" prop="itemName">
              <el-input v-model="form.itemName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_commodity_edit_dialog.gui_ge_xing_hao')" prop="itemSpec">
              <el-input v-model="form.itemSpec" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_commodity_edit_dialog.dan_wei')" prop="itemUnit">
              <el-input v-model="form.itemUnit" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fms_commodity_edit_dialog.shui_lv')" prop="taxRate">
              <el-input v-model="form.taxRate" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveGroup">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      form: {
        billType: '', // 账单类型，10-租赁，12-违约，13-逾期，100-库存管理
        invoiceType: '', // 开票类型 1-增值税普通发票，2-增值税专用发票，3-增值税电子普通发票
        itemCode: '', // 服务项编码（航天金税商品Id）
        itemName: '', // 服务项名称
        itemNum: '', // 数量
        itemSpec: '', // 规格
        itemUnit: '', // 单位
        partnerInvoiceId: '', // 发票Id
        partnerInvoiceItemId: '', // 发票明细Id [编辑必填]
        taxRate: '', // 税率
      },
      editOff: false,
    };
  },
  computed: {
    rules() {
      return {
        invoiceType: {
          required: true,
          message: this.$t('fms_commodity_edit_dialog.qxzmrkplx'),
        },
        billType: {
          required: true,
          message: this.$t('fms_commodity_edit_dialog.qxzfylx'),
        },
        itemName: {
          required: true,
          message: this.$t('fms_commodity_edit_dialog.qtxspmc'),
        },
        itemSpec: {
          required: true,
          message: this.$t('fms_commodity_edit_dialog.qtxggxh'),
        },
        itemUnit: {
          required: true,
          message: this.$t('fms_commodity_edit_dialog.qtxdw'),
        },
        taxRate: {
          required: true,
          message: this.$t('fms_commodity_edit_dialog.qtxsl'),
        },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.editOff = false;
      }
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.data);
        // this.pushConfId = this.model.data.pushConfId;
        // 编辑 disabled
        this.editOff = true;
      }
    },

    // 确认保存分组
    saveGroup: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.saveEditItem();
      });
    },

    saveEditItem: function () {
      this.$postJSON(apis.crmPartnerInvoiceItemUpdate, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss"></style>
